import React from 'react';
import { Paper, Typography, Box, Stack } from '@mui/material';
import { USERS } from './choreConstants';

const AvatarSelection = ({ onSelect }) => {
    return (
        <Stack 
            direction="row" 
            spacing={2} 
            sx={{ 
                height: '75vh', 
                alignItems: 'stretch',
                justifyContent: 'center',
                width: '100%',
                mt: 4
            }}
        >
            {USERS.map(user => (
                <Box key={user.id} sx={{ flex: 1, minWidth: 0 }}>
                    <Paper 
                        elevation={6}
                        sx={{ 
                            p: 2, 
                            cursor: 'pointer',
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            borderRadius: 4,
                            bgcolor: 'white',
                            '&:hover': { 
                                transform: 'scale(1.02) translateY(-10px)',
                                boxShadow: 20
                            },
                            '&:active': {
                                transform: 'scale(0.98)'
                            }
                        }}
                        onClick={() => onSelect(user.id)}
                    >
                        <Box 
                            sx={{ 
                                position: 'relative',
                                width: '80%',
                                pb: '80%', // Aspect ratio 1:1
                                mb: 4,
                                borderRadius: '50%',
                                overflow: 'hidden',
                                boxShadow: 3
                            }}
                        >
                             <Box 
                                component="img" 
                                src={`${user.avatar}`} 
                                sx={{ 
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%', 
                                    height: '100%',
                                    objectFit: 'cover' 
                                }}
                                onError={(e) => { e.target.src = 'https://via.placeholder.com/200?text=' + user.name[0] }}
                            />
                        </Box>
                        <Typography variant="h3" fontWeight="900" sx={{ color: '#2d3748', fontSize: { xs: '1.5rem', md: '2.5rem', lg: '3rem' } }}>
                            {user.name}
                        </Typography>
                    </Paper>
                </Box>
            ))}
        </Stack>
    );
};

export default AvatarSelection;
